module.exports = __webpack_public_path__ + "img/26.4.NH3-N.ad8756bc.png";